import { Field } from "csi/def/Field";
import Widget from "csi/form/Widget";
import declare from "dojo/_base/declare";

const DateForm = declare(Widget, {

	/**
	 * @override
	 * Force 'ActualEnd' field to be editable
	 *
	 * @param field
	 * @returns
	 */
	isFieldEditable(field: Field): boolean {
		if (field.m_id == "ActualEnd")
			return true;

		return this.inherited<boolean>(arguments);
	},
});

export = DateForm;